import { render } from "./FormCodigoDescuento.vue?vue&type=template&id=8943c82c"
import script from "./FormCodigoDescuento.vue?vue&type=script&lang=js"
export * from "./FormCodigoDescuento.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__